import {createFileRoute} from '@tanstack/react-router';
import {RenderNothing} from '../router/route-components';

export const Route = createFileRoute('/$')({
  component: RenderNothing,
});
